import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";
import { rememberSettingsReturnTo, resetSettingsReturnTo } from "@/lib/settingsReturnTo";

/** Records the last non-settings app location so settings “back” can return there. */
export function useRememberSettingsReturnTo(): void {
  const { pathname, search, hash } = useLocation();
  const { user } = useAuth();
  const userId = user?.id ?? null;
  const lastUserIdRef = useRef(userId);

  if (lastUserIdRef.current !== userId) {
    lastUserIdRef.current = userId;
    resetSettingsReturnTo();
  }

  useEffect(() => {
    rememberSettingsReturnTo(pathname, search, hash);
  }, [hash, pathname, search]);
}
